import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PromiseStatuses } from "../../../utils";
import { GetAllPersonaleContabileFiltersDTO, GetAllPersonaleContabileResponseData } from "./dataService/dto";
import { NewPersonaleContabileService } from "./dataService/service";

interface PersonaleContabileState {
    // FILTERS
    GetAllPersonaleContabileFilters: GetAllPersonaleContabileFiltersDTO
    getAllPersonaleContabiletatus: PromiseStatuses
    GetAllPersonaleContabileResponse?: GetAllPersonaleContabileResponseData[]

}

const initialState: PersonaleContabileState = {

    GetAllPersonaleContabileFilters: {
        itemsPerPage: 500,
        page: 0
    },

    getAllPersonaleContabiletatus: 'idle',
}

export const GetAllPersonaleContabile = createAsyncThunk(
    'personaleContabile/GetAllPersonaleContabile',
    async (filters: GetAllPersonaleContabileFiltersDTO, thunkApi): Promise<GetAllPersonaleContabileResponseData[]> => {
        const personaleContabileService = NewPersonaleContabileService()

        return personaleContabileService.GetAllPersonaleContabile(filters).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

const PersonaleContabileSlice = createSlice({
    name: 'monitoringFaseAvvio/slice',
    initialState,
    reducers: {
        // FILTERS
        setGetAllPersonaleContabileFiltersItemsPerPage: (state, action) => {
            state.GetAllPersonaleContabileFilters.itemsPerPage = action.payload
        },
        setGetAllPersonaleContabileFiltersPage: (state, action) => {
            state.GetAllPersonaleContabileFilters.page = action.payload
        },
        setGetAllPersonaleContabileFiltersOrder: (state, action) => {
            state.GetAllPersonaleContabileFilters.order = action.payload
        },
        setGetAllPersonaleContabileFiltersSort: (state, action) => {
            state.GetAllPersonaleContabileFilters.sort = action.payload
        },
        setGetAllPersonaleContabileYear: (state, action) => {
            state.GetAllPersonaleContabileFilters.year = action.payload
        },
        setGetAllPersonaleContabileStatus: (state, action) => {
            state.GetAllPersonaleContabileFilters.status = action.payload
        },
        setGetAllPersonaleContabileInvoice: (state, action) => {
            state.GetAllPersonaleContabileFilters.invoice = action.payload
        },
        setGetAllPersonaleContabileProformaStatus: (state, action) => {
            state.GetAllPersonaleContabileFilters.proformaStatus = action.payload
        },
        setGetAllPersonaleContabileNorm: (state, action) => {
            state.GetAllPersonaleContabileFilters.norm = action.payload
        },
        setGetAllPersonaleContabileInspectorCode: (state, action) => {
            state.GetAllPersonaleContabileFilters.inspectorCode = action.payload
        },
        resetGetAllPersonaleContabileFilters: (state) => {
            state.GetAllPersonaleContabileFilters = {
                itemsPerPage: 500,
                page: 0
            }
        },
    },
    extraReducers(builder) {
        builder

            // GET ALL
            .addCase(GetAllPersonaleContabile.pending, (state) => {
                state.getAllPersonaleContabiletatus = 'loading'
            })
            .addCase(GetAllPersonaleContabile.fulfilled, (state, action) => {
                state.getAllPersonaleContabiletatus = 'successfully'
                state.GetAllPersonaleContabileResponse = action.payload
            })
            .addCase(GetAllPersonaleContabile.rejected, (state) => {
                state.getAllPersonaleContabiletatus = 'failed'
            })

    },
})

export const {
    setGetAllPersonaleContabileYear,
    setGetAllPersonaleContabileFiltersItemsPerPage,
    setGetAllPersonaleContabileFiltersOrder,
    setGetAllPersonaleContabileFiltersPage,
    setGetAllPersonaleContabileFiltersSort,
    setGetAllPersonaleContabileInvoice,
    setGetAllPersonaleContabileNorm,
    setGetAllPersonaleContabileInspectorCode,
    setGetAllPersonaleContabileProformaStatus,
    setGetAllPersonaleContabileStatus,
    resetGetAllPersonaleContabileFilters
} = PersonaleContabileSlice.actions

export default PersonaleContabileSlice.reducer